import { useGameStore } from '../../store/gameStore';
import { OuterWorld } from './games/OuterWorld';
import { SnakeGame } from './games/SnakeGame';
import { BreakoutGame } from './games/BreakoutGame';
import { ReactionGame } from './games/ReactionGame';

export function LayerRenderer() {
  const layers = useGameStore((s) => s.layers);
  const currentDepth = useGameStore((s) => s.currentDepth);

  return (
    <div className="relative">
      {layers.map((layer, depth) => (
        <div key={depth} className={depth === currentDepth ? 'block' : 'hidden'}>
          {layer.type === 'outer-world' && <OuterWorld active={depth === currentDepth} />}
          {layer.type === 'snake' && <SnakeGame active={depth === currentDepth} />}
          {layer.type === 'breakout' && <BreakoutGame active={depth === currentDepth} />}
          {layer.type === 'reaction' && <ReactionGame active={depth === currentDepth} />}
        </div>
      ))}
    </div>
  );
}
